
import { AlertTriangle } from "lucide-react";

interface PasswordValidationDisplayProps {
  errors: string[];
}

const PasswordValidationDisplay = ({ errors }: PasswordValidationDisplayProps) => {
  if (errors.length === 0) return null;
  
  return (
    <div className="text-sm mt-2 text-destructive">
      <p className="font-medium flex items-center gap-1">
        <AlertTriangle className="h-3 w-3" />
        Parool peab vastama järgmistele nõuetele:
      </p>
      <ul className="list-disc list-inside mt-1 ml-1 text-xs">
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordValidationDisplay;
